import { styled } from '@mui/material';

export const PaddingLeft = styled('div')({
  paddingLeft: '34px',
});
